import { render, staticRenderFns } from "./control-collection.vue?vue&type=template&id=532618b5"
import script from "./control-collection.vue?vue&type=script&lang=js"
export * from "./control-collection.vue?vue&type=script&lang=js"
import style0 from "./control-collection.vue?vue&type=style&index=0&id=532618b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports